import { importJWK, jwtVerify } from 'jose';

/**
 * IMPORTANT: This file is also included in storybook middleware to simulate server side
 *            so don't get crazy with frontend stuff here.
 */

export class VerifyPatch {
  static publicKey = null;

  constructor({ publicKey, store }) {
    this.publicKey = publicKey;
    this.store = store;
  }

  async key() {
    this._key ||= await importJWK(this.publicKey, 'RS256');
    return this._key;
  }

  async verifySignature(payload) {
    const { signature, patches } = payload;

    // eslint-disable-next-line no-unreachable
    const ecPublicKey = await this.key();
    let jwtPayload = {};

    try {
      const result = await jwtVerify(signature, ecPublicKey);
      jwtPayload = result.payload;
    } catch (error) {
      console.error(error);
    }

    // Filter out all invalid patches
    return patches.filter(patch => {
      const { path, value } = patch;

      const [_namespace1, chatId, namespace2, messageId, attribute] = path;

      if (chatId !== String(jwtPayload.chat_id)) return false;

      // Attributes from other users
      if (['readIds', 'receivedAt'].includes(attribute)) return true;

      if (namespace2 == 'messages' && messageId) {
        const message = this.store.chats.get(chatId).messages.get(messageId);

        // Existing message
        if (message && message.userId !== jwtPayload.user_id) return false;

        // New message
        if (!message && value.userId !== jwtPayload.user_id) return false;
      }

      return true;
    });
  }
}
